import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { FormGroup, Input, Label, Button } from "reactstrap";
import ReactCreditCard from "react-credit-cards";
import Payment from "payment";
import { StatesList } from "../../Code/Data";
import CustomSelect from "../../Components/Common/CustomSelect";
import "../../../src/css/styles-compiled.css";

export default class PaymentForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      number: "",
      name: "",
      expiry: "",
      cvc: "",
      focused: "",
      address: "",
      zip: "",
      state: "",
      city: "",
    };
  }

  componentDidMount() {
    Payment.formatCardNumber(document.querySelector('[name="number"]'));
    Payment.formatCardExpiry(document.querySelector('[name="expiry"]'));
    Payment.formatCardCVC(document.querySelector('[name="cvc"]'));
  }

  handleInputFocus = ({ target }) => {
    this.setState({
      focused: target.name,
    });
  };

  handleInputChange = ({ target }) => {
    if (target.name === "number") {
      this.setState(
        {
          number: target.value.replace(/ /g, ""),
        },
        this.onChange
      );
    } else if (target.name === "expiry") {
      let expiry = target.value.replace(/ |\//g, "");
      if (target.value.length > 4) {
        expiry = expiry.slice(0, 2) + expiry.slice(-2);
      }
      this.setState({ expiry }, this.onChange);
    } else {
      this.setState(
        {
          [target.name]: target.value,
        },
        this.onChange
      );
    }
  };

  handleCallback(type, isValid) {
    console.log(type, isValid); //eslint-disable-line no-console
  }

  onChange = () => {
    const { number, expiry, cvc, address, zip, state, city } = this.state;
    console.log({ number, expiry, cvc, address, zip, state, city });
    const creditData = {
      Address: address,
      Zip: zip,
      State: state,
      City: city,
      ExpirationDateMonth: expiry.substr(0, 2), //integer
      ExpirationDateYear: expiry.slice(-2), //integer
      CreditCardNumber: number,
      CVV: cvc,
    };
    this.props.onChange(creditData);
  };

  render() {
    const { name, number, expiry, cvc, focused, state } = this.state;
    return (
      <Fragment>
        <h4>
          <u>Credit Card Information</u>
        </h4>
        <ReactCreditCard
          number={number}
          name={name}
          expiry={expiry}
          cvc={cvc}
          focused={focused}
          callback={this.handleCallback}
        />
        <FormGroup className="has-float-label mt-4">
          <Input
            type="tel"
            id="number"
            name="number"
            placeholder="Card Number"
            onKeyUp={this.handleInputChange}
            onFocus={this.handleInputFocus}
          />
          <Label for="number">Card Number</Label>
        </FormGroup>
        {!this.props.isAddToDonation && (
          <FormGroup className="has-float-label">
            <Input
              type="text"
              id="name"
              name="name"
              placeholder="Name"
              onKeyUp={this.handleInputChange}
              onFocus={this.handleInputFocus}
            />
            <Label for="name">Name</Label>
          </FormGroup>
        )}
        <FormGroup className="has-float-label cc-half-left d-inline-block">
          <Input
            type="tel"
            id="expiry"
            name="expiry"
            placeholder="Valid Thru"
            onKeyUp={this.handleInputChange}
            onFocus={this.handleInputFocus}
          />
          <Label for="expiry">Exp</Label>
        </FormGroup>
        <FormGroup className="has-float-label cc-half-right d-inline-block">
          <Input
            type="tel"
            id="cvc"
            name="cvc"
            placeholder="CVC"
            onKeyUp={this.handleInputChange}
            onFocus={this.handleInputFocus}
          />
          <Label for="cvc">CVC</Label>
        </FormGroup>

        {this.props.isAddToDonation && (
          <Fragment>
            <h4>
              <u>Billing Information</u>
            </h4>
            <FormGroup className="has-float-label">
              <Input
                type="text"
                id="name"
                name="name"
                placeholder="Name"
                onKeyUp={this.handleInputChange}
                onFocus={this.handleInputFocus}
              />
              <Label for="name">Name</Label>
            </FormGroup>
          </Fragment>
        )}

        <FormGroup className="has-float-label cc-half-left d-inline-block w-100">
          <Input
            type="text"
            name="creditCardAddress"
            id="creditCardAddress"
            placeholder="Address"
            // defaultValue={address}
            onChange={e =>
              this.setState({ address: e.target.value }, this.onChange)
            }
          />
          <Label for="creditCardAddress">Address</Label>
        </FormGroup>
        <FormGroup className="has-float-label cc-half-right d-inline-block">
          <Input
            name="creditCardCity"
            id="creditCardCity"
            placeholder="City"
            // defaultValue={city}
            onChange={e =>
              this.setState({ city: e.target.value }, this.onChange)
            }
          />
          <Label for="creditCardCity">City</Label>
        </FormGroup>
        <FormGroup className="has-float-label cc-half-left d-inline-block w-100">
          <CustomSelect
            name="creditCardState"
            placeholder="State"
            options={StatesList}
            selectedValue={state}
            onChange={selectedState =>
              this.setState({ state: selectedState }, this.onChange)
            }
          />
        </FormGroup>
        <FormGroup className="has-float-label cc-half-right d-inline-block">
          <Input
            type="number"
            name="creditCardZip"
            id="creditCardZip"
            placeholder="ZIP Code"
            onChange={e =>
              this.setState({ zip: e.target.value }, this.onChange)
            }
          />
          <Label for="creditCardZip">ZIP Code</Label>
        </FormGroup>

        {this.props.withSaveButton && (
          <span className="w-100 text-center d-inline-block">
            <Button color="primary" onClick={this.onChange}>
              Submit Payment
            </Button>
          </span>
        )}
      </Fragment>
    );
  }
}
PaymentForm.propTypes = {
  onChange: PropTypes.func,
};
PaymentForm.defaultProps = {
  onChange: () => {},
};
